<template>
    <div class="item-display mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0">Items</h4>
            <button
                type="button"
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#itemModal"
            >
                <font-awesome-icon icon="plus" class="me-1" /> Add
            </button>
        </div>

        <hr />

        <div class="row" v-if="character && Array.isArray(character.items)">
            <div
                class="col-sm-12 mb-3"
                v-for="(item, index) in character.items || []"
                :key="item.name"
            >
                <div class="d-flex justify-content-between align-items-center">
                    <strong
                        @click="selectedItem = item.name"
                        data-bs-toggle="modal"
                        data-bs-target="#viewItemModal"
                        style="cursor: pointer"
                    >
                        {{ item.name || "Unnamed Item" }}
                    </strong>
                    <span class="badge bg-info ms-2">{{ item.type }}</span>
                </div>
                <hr v-if="index < (character.items?.length || 0) - 1" />
            </div>
        </div>
    </div>

    <!-- Add Item Modal -->
    <div
        class="modal fade"
        id="itemModal"
        tabindex="-1"
        aria-labelledby="itemModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title" id="itemModalLabel">Add Item</h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3" role="tablist">
                        <li class="nav-item">
                            <button
                                class="nav-link active"
                                data-bs-toggle="tab"
                                data-bs-target="#premadeItemTab"
                                type="button"
                                role="tab"
                                @click="activeTab = 'premade'"
                            >
                                Premade
                            </button>
                        </li>
                        <li class="nav-item">
                            <button
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#customItemTab"
                                type="button"
                                role="tab"
                                @click="activeTab = 'custom'"
                            >
                                Custom
                            </button>
                        </li>
                    </ul>

                    <div class="tab-content">
                        <!-- Premade -->
                        <div
                            class="tab-pane fade show active"
                            id="premadeItemTab"
                            role="tabpanel"
                        >
                            <div class="input-group mb-3">
                                <span class="input-group-text">Premade Item</span>
                                <select
                                    class="form-select"
                                    v-model="selectedItem"
                                    @change="fillFromPreset"
                                >
                                    <option value="">Select...</option>
                                    <option
                                        v-for="item in rosterStore.items.sort((a, b) =>
                                            a.name.localeCompare(b.name)
                                        )"
                                        :key="item.name"
                                        :value="item.name"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>

                            <div v-if="selectedItem">
                                <h5><strong>{{ newItem.name }}</strong></h5>
                                <p><strong>Type:</strong> {{ newItem.type }}</p>
                                <div v-if="newItem.ability.length">
                                    <strong>Abilities:</strong>
                                    <ul>
                                        <li
                                            v-for="(ab, i) in newItem.ability"
                                            :key="i"
                                        >
                                            <strong>{{ ab }}</strong>:
                                            {{
                                                abilityLookup.get(ab)?.description ||
                                                "No description."
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Custom -->
                        <div
                            class="tab-pane fade"
                            id="customItemTab"
                            role="tabpanel"
                        >
                            <div class="input-group mb-3">
                                <span class="input-group-text">Name</span>
                                <input
                                    v-model="newItem.name"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <div class="input-group mb-3">
                                <span class="input-group-text">Type</span>
                                <input
                                    v-model="newItem.type"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <!-- Abilities -->
                            <div class="input-group mb-3">
                                <span class="input-group-text">Abilities</span>
                                <select
                                    v-model="selectedAbility"
                                    class="form-select"
                                >
                                    <option disabled value="">Select...</option>
                                    <option
                                        v-for="ability in rosterStore.itemAbilities.sort(
                                            (a, b) => a.name.localeCompare(b.name)
                                        )"
                                        :key="ability.name"
                                        :value="ability.name"
                                    >
                                        {{ ability.name }}
                                    </option>
                                </select>
                                <button
                                    class="btn btn-outline-primary"
                                    type="button"
                                    @click="addAbility"
                                >
                                    Add
                                </button>
                            </div>

                            <!-- Custom Ability -->
                            <div class="input-group mb-3">
                                <span class="input-group-text">Custom Ability</span>
                                <input
                                    v-model="customAbilityName"
                                    type="text"
                                    class="form-control"
                                    placeholder="Name"
                                />
                                <input
                                    v-model="customAbilityDesc"
                                    type="text"
                                    class="form-control"
                                    placeholder="Description"
                                />
                                <button
                                    class="btn btn-outline-primary"
                                    type="button"
                                    @click="addCustomAbility"
                                >
                                    Add
                                </button>
                            </div>

                            <!-- Selected abilities -->
                            <div v-if="newItem.ability.length" class="mb-3">
                                <strong>Selected Abilities:</strong>
                                <div class="d-flex flex-wrap gap-2 mt-2">
                                    <span
                                        v-for="(ab, i) in newItem.ability"
                                        :key="i"
                                        class="badge bg-success d-flex align-items-center"
                                        style="font-size: 1rem; padding: 0.5em 0.75em;"
                                    >
                                        {{ ab }}
                                        <button
                                            type="button"
                                            class="btn-close btn-close-white ms-2"
                                            style="font-size: 0.6rem"
                                            @click="confirmRemoveAbility(i)"
                                        ></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="multiply" class="me-1" /> Close
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="addItem(activeTab)"
                    >
                        <font-awesome-icon icon="plus" class="me-1" /> Add Item
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- View Item Modal -->
    <div
        class="modal fade"
        id="viewItemModal"
        tabindex="-1"
        aria-labelledby="viewItemModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title" id="viewItemModalLabel" v-if="selectedItem">
                        {{ selectedItem }}
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body" v-if="currentItem">
                    <h5><strong>{{ currentItem.name }}</strong></h5>
                    <p><strong>Type:</strong> {{ currentItem.type }}</p>
                    <div v-if="currentItem.ability?.length">
                        <strong>Abilities:</strong>
                        <ul>
                            <li v-for="(ab, i) in currentItem.ability" :key="i">
                                <strong>{{ ab }}</strong>:
                                {{ abilityLookup.get(ab)?.description || "No description." }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="multiply" class="me-1" /> Close
                    </button>
                    <button
                        type="button"
                        class="btn btn-danger"
                        @click="deleteItem(currentItem?.name)"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="trash-alt" class="me-1" /> Remove Item
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useRosterStore } from "../stores/index";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    name: "ItemDisplay",
    components: { FontAwesomeIcon },
    props: {
        character: { type: Object, required: true },
    },
    data() {
        return {
            selectedItem: null,
            activeTab: "premade",
            newItem: {
                name: "",
                type: "",
                ability: [],
            },
            selectedAbility: "",
            customAbilityName: "",
            customAbilityDesc: "",
        };
    },
    computed: {
        ...mapStores(useRosterStore),
        currentItem() {
            return Array.isArray(this.character?.items)
                ? this.character.items.find((i) => i.name === this.selectedItem)
                : null;
        },
        abilityLookup() {
            const src = this.rosterStore?.itemAbilities ?? [];
            const map = new Map();
            if (Array.isArray(src)) {
                src.forEach((a) => {
                    if (a?.name)
                        map.set(a.name, {
                            name: a.name,
                            description: a.description ?? "",
                        });
                });
            }
            return map;
        },
    },
    methods: {
        resetNewItem() {
            this.newItem = { name: "", type: "", ability: [] };
            this.selectedAbility = "";
            this.customAbilityName = "";
            this.customAbilityDesc = "";
        },
        fillFromPreset() {
            if (!this.selectedItem) {
                this.resetNewItem();
                return;
            }
            const preset = this.rosterStore.items.find(
                (i) => i.name === this.selectedItem
            );
            if (preset) {
                this.newItem = { ...preset, ability: [...preset.ability] };
            }
        },
        addItem(source = "custom") {

            if (!this.newItem.name) {
                alert("Item must have a name!");
                return;
            }
            if (!this.newItem.type) {
                alert("Item must have a type!");
                return;
            }
            if (this.customAbilityName.trim() || this.customAbilityDesc.trim()) {
                alert("You have entered a custom ability but not added it!");
                return;
            }
            if (this.selectedAbility !== "") {
                alert("You have selected an ability but not added it!");
                return;
            }

            const itemToAdd = { ...this.newItem, ability: [...this.newItem.ability] };
            this.character.items.push(itemToAdd);

            if (source === "custom") {
                if (!this.rosterStore.items.find((i) => i.name === itemToAdd.name)) {
                    this.rosterStore.items.push(itemToAdd);
                }
                for (const ab of itemToAdd.ability) {
                    if (!this.abilityLookup.has(ab)) {
                        this.rosterStore.itemAbilities.push({
                            name: ab,
                            description: "No description.",
                        });
                    }
                }
            }

            this.selectedItem = null;
            this.resetNewItem();
            alert("Item added!");
        },
        deleteItem(name) {
            if (!name) return;
            if (!Array.isArray(this.character?.items)) return;
            if (confirm(`Are you sure you want to delete ${name}?`)) {
                const index = this.character.items.findIndex((i) => i.name === name);
                if (index !== -1) this.character.items.splice(index, 1);
                this.selectedItem = null;
            }
        },
        addAbility() {
            if (!this.selectedAbility) return;
            if (!this.newItem.ability.includes(this.selectedAbility)) {
                this.newItem.ability.push(this.selectedAbility);
            }
            this.selectedAbility = "";
        },
        addCustomAbility() {
            const name = this.customAbilityName.trim();
            const desc = this.customAbilityDesc.trim();
            if (!name || !desc) {
                alert("Custom abilities need both Name and Description!");
                return;
            }
            this.newItem.ability.push(name);
            this.rosterStore.itemAbilities.push({ name, description: desc });
            this.customAbilityName = "";
            this.customAbilityDesc = "";
        },
        confirmRemoveAbility(index) {
            const ab = this.newItem.ability[index];
            if (confirm(`Remove ability "${ab}"?`)) {
                this.newItem.ability.splice(index, 1);
            }
        },
    },
};
</script>

<style scoped>
.item-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}
</style>

